export default "__VITE_ASSET__DJI7h_0J__"